import * as React from "react";
import type { SVGProps } from "react";
const SvgEyeSlashed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m10.71 14.7-1.65 1.66-1.51 1.5-1.84 1.85a1.001 1.001 0 0 1-1.639-.325 1 1 0 0 1 .219-1.095l1.55-1.54c-.27-.2-.53-.42-.78-.64a15.5 15.5 0 0 1-2.93-3.61 1 1 0 0 1 0-1C4 8.36 7.5 5 12 5a9.35 9.35 0 0 1 3.45.69c.36.14.68.29 1 .45l1.82-1.84a1.003 1.003 0 1 1 1.42 1.42l-1.55 1.54-1.43 1.44-6 6ZM4.17 12a13.081 13.081 0 0 0 2.32 2.7v-.01c.252.214.516.414.79.6l2-2A3.08 3.08 0 0 1 9 12.16.998.998 0 0 1 9 12a3 3 0 0 1 3-3h.16a3.08 3.08 0 0 1 1.13.3l1.61-1.66a9.166 9.166 0 0 0-1-.37A7 7 0 0 0 12 7c-3.41 0-6.27 2.59-7.83 5Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.94 7.89a15.5 15.5 0 0 1 2.93 3.61 1 1 0 0 1 0 1C20.05 15.64 16.5 19 12 19a9.35 9.35 0 0 1-3.48-.69l1.58-1.58A6.998 6.998 0 0 0 12 17c3.41 0 6.27-2.59 7.83-5a13.078 13.078 0 0 0-2.32-2.69l1.43-1.42Z"
    />
  </svg>
);
export default SvgEyeSlashed;
